import { NumericInput } from "@blueprintjs/core";
import { useContext, useEffect, useState } from "react";
import PageContext from "../Context/PageContext";
import { isDesktop, isMobile, isTablet, useMobileOrientation } from "react-device-detect";
import Preview from "./Preview";

import $ from 'jquery'

import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import axios from "axios";
import { AddExistingPoint, AddPoint, AddTrace } from "../Util/ActivitesUtil";
import { SaveTemplate } from "../Util/SaveUtil";
import Cart from "./Cart";
import { useReactToPrint } from "react-to-print";

import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';

import generatePDF, { Resolution, Margin } from 'react-to-pdf';

import domtoimage from 'dom-to-image';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ExportJSON, ExportPdf } from "../Util/ExportUtil";
import Guide from "./Guide";

import uniqid from 'uniqid'
import SaveButton from "./SaveButton";
import CartJSON from "./CartJSON";


export default function Header() {

    const { selectedItem, setSelectedItem,
        objItems, setObjItems,
        mapListPoint, setMapListPoint, addMapListPoint,
        mapListTrace, setMapListTrace,
        addMapSource, addMapLayer, traceStyle, traceLayout, addMapListTrace,
        pageSize, setPageSize,
        pageColor, setPageColor,
        mapPosition, setMapPosition,
        mapIndex, setMapIndex,
        mapTaille, setMapTaille,
        mapUrlStyle, setMapUrlStyle,
        modeAdmin, elevationData,
        isMode3D, page,
        jsonFormat, isPortrait, setIsPortrait, mapLock } = useContext(PageContext);


    const handlePrint = useReactToPrint({
        content: () => page.current,
    });

    const { isLandscape } = useMobileOrientation();


    function dowload_img() {
        //Object.defineProperty(window, "devicePixelRatio", { get: function(){return 400 / 96; }});

        /* unselect selectedItem */
        $('.selected-element').removeClass("selected-element");
        //set selectedItem context to null !
        if (selectedItem != null && setSelectedItem != null) setSelectedItem(null);
        /* disable mapbox text items*/
        $('div[class*=mapboxgl-ctrl]').hide();

        const i = document.getElementById('page') as HTMLElement;
        /*var map = (window as any).$map;


        const getTargetElement = () => document.getElementById('page');

        const options = {
            method: "open",
            resolution: Resolution.HIGH,
            page: {
                margin: Margin.SMALL,
                format: 'letter',
                orientation: 'portrait',
            },
            canvas: {
                mimeType: 'image/png',
                qualityRatio: 1
            },
        };

        // Generate map clone with higher resolution

        const actualPixelRatio: number = window.devicePixelRatio;
        var map_init = (window as any).$map;
        Object.defineProperty(window, "devicePixelRatio", { get: function () { return 600 / 96; } });

        const renderMap = new mapboxgl.Map({
            accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN != null ? process.env.REACT_APP_MAPBOX_ACCESS_TOKEN : "",
            container: document.getElementsByClassName('map-element')[0] as HTMLElement,
            style: map.getStyle(),
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch(),
            interactive: false,
            preserveDrawingBuffer: true,
            fadeDuration: 0,
            attributionControl: false,
            // hack to read transfrom request callback function
            //transformRequest: (this.map as any)._requestManager._transformRequestFn,
        });

        (window as any).$map = renderMap;

        mapListPoint.forEach((element: any) => {
            AddExistingPoint(element, { mapListPoint, addMapListPoint });
        });

        renderMap.once('idle', async () => {
            const document = await generatePDF(getTargetElement, {
                filename: 'page.pdf',
                method: "build",
                resolution: Resolution.HIGH,
                page: {
                    format: 'a4',
                    orientation: 'portrait',
                },
                overrides: {
                    canvas: {
                        imageTimeout: 100000,
                        proxy: 'https://affichemap.fr'
                    }
                }
            })

            console.log(document)

            const base64 = document.output("datauristring")
            console.log(base64)

            renderMap.remove();

            (window as any).$map = map_init;


            Object.defineProperty(window, 'devicePixelRatio', {
                get() { return actualPixelRatio; },
            });


        });

        // FIN
        */


        //generatePDF(getTargetElement, {filename: 'page.pdf', resolution: Resolution.HIGH, overrides: {canvas: { useCORS: true }}})

        //Object.defineProperty(window, "devicePixelRatio", { get: function(){return 96 / 96; }});

        //map.setPixelRatio(4)
        /*window.devicePixelRatio = 9;
        var map = (window as any).$map;
        const mapCanvas = map.getCanvas();

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = mapCanvas.width;
        canvas.height = mapCanvas.height;
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        if(context != null) {
            context.drawImage(mapCanvas, 0, 0);
            // after image loads
        let fileName = `ImageName.png`
        const link = document.createElement('a')
        link.href = canvas.toDataURL("image/png").replace("image/png", 
         "image/octet-stream")
        link.download = fileName
        link.click();
        }*/

        //map.addImage()

        //pixel ratio multiplie par la valeur la taille  de l'image (pas d'impact sur mapbox...)
        //htmlToImage.toPng(i, { pixelRatio: 1, quality: 0.5 })
        htmlToImage.toJpeg(i, { quality: 0.2 })
            .then(function (dataUrl) {
                console.log("img download")
                var link = document.createElement('a');
                link.download = 'image_modele_admin_mode.png';
                link.href = dataUrl;
                link.click();
                $('div[class*=mapboxgl-ctrl]').show();
            }).catch(function (error) {
                console.error('oops, something went wrong!', error);
                $('div[class*=mapboxgl-ctrl]').show();
            });
    }

    async function genImg(node: any) {
        var imgGen = await htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;

                return img;

                /*node[0].appendChild(img);
    
                node[0].style.mask = 'none';
                node[0].style.webkitMaskComposite = 'none';
                node[0].style.backgroundColor = 'transparent'*/

            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    function dowload_pdf() {
        ExportPdf(true, null, {
            objItems,
            selectedItem, setSelectedItem,
            mapListPoint, addMapListPoint,
            pageSize, jsonFormat, isPortrait, setIsPortrait
        })

    }

    /*function test_cart() {
        ExportJSON({
            mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock,
            selectedItem, setSelectedItem, addMapListPoint, jsonFormat, setIsPortrait,
        });

    }*/

    function importTemplate(val: any) {
        axios(val)
            .then((res) => {
                console.log(res)
                loadTemplate(res.data);
            })
    }

    function loadTemplate(val: any) {

        //Gestion de la page : taille et couleur
        if (setPageSize != null) setPageSize(val.pageSize);
        if (setPageColor != null) setPageColor(val.pageColor);

        //Gestion de la map : position et taille et theme, ZOOM TODO!!
        if (setMapPosition != null) setMapPosition(val.mapPosition)
        if (setMapTaille != null) setMapTaille(val.mapTaille)
        if (setMapIndex != null) setMapIndex(val.mapIndex != undefined ? val.mapIndex : 0)

        if (setMapUrlStyle != null) setMapUrlStyle(val.mapUrlStyle)
        var map = (window as any).$map;
        map.setStyle(val.mapUrlStyle);

        // Gestion des éléments
        if (setObjItems != null) setObjItems(val.objItems);

        //on a besoin d'un délai après changer le style
        setTimeout(() => {
            console.log("Delayed for 1 second.");
            //TO DO JUST AFTER
            //Gestion des points GPS
            /* On peut pas se permettre de gérer les traces comme les objets dans des listes, au risque de recharger les tracés très souvent*/
            const copyItemsPoint: any[] = [];
            val.mapListPoint.forEach((element: any) => {
                var newPoint = AddPoint(element.city, element.coordinates, element.type, element.id, { mapListPoint, addMapListPoint });
                copyItemsPoint.push(newPoint);
            });

            if (addMapListPoint != null) addMapListPoint(copyItemsPoint);

            //Gestion des tracés

            /* supprimer les tracés existants ? */
            /* NON, car utilisateur veut ses propres tracé */
            /* On peut pas se permettre de gérer les traces comme les objets dans des listes, au risque de recharger les tracés très souvent*/
            const copyItemsTrace: any[] = [];
            val.mapListTrace.forEach((element: any) => {
                var newTrace = AddTrace(element.name, element.sourceData, element.sourceData, element.type, element.point1, element.point2, element.id, element.traceStyle,
                    { addMapSource, addMapLayer, traceStyle, traceLayout, mapListTrace, addMapListTrace });

                copyItemsTrace.push(newTrace)
            });

            if (addMapListTrace != null) addMapListTrace(copyItemsTrace);

        }, 1000);
    }

    function goBackHome(): void {
        window.location.href = "https://affichemap.fr";
    }

    function exportTemplate() {

        const exportJSON = SaveTemplate({ mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock, jsonFormat })

        /* download file*/
        const filename = uniqid() + '.json';

        /*const jsonStr = JSON.stringify(exportJSON);
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(jsonStr));

        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);*/

        //nouveau test
        // create file in browser
        //const json = JSON.stringify(exportJSON, null, 2);
        const json = JSON.stringify(exportJSON);
        const blob = new Blob([json], { type: "application/json" });
        const href = URL.createObjectURL(blob);

        // create "a" HTLM element with href to file
        const link = document.createElement("a");
        link.href = href;
        link.download = uniqid() + ".json";
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);

    }

    /*function saveLocalStorage() {

        var exportJSON = SaveTemplate({ mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock })

        window.localStorage.setItem('affiche_map_context', JSON.stringify(exportJSON));

        var lastMajDate = new Date().toLocaleDateString('fr-FR', { year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }).replace(',', '');

        if (setMajDate != null) setMajDate(lastMajDate)
    }*/

    function onFileUpload() {
        $('#upload-file').click();
    }

    function fileActionUpload(event: any) {
        // Create an object of formData
        const formData = new FormData();

        const reader = new FileReader();
        reader.onload = async (e) => {

            var fileText = null;
            if (e.target != null) fileText = e.target.result as string;

            if (fileText != null) loadTemplate(JSON.parse(fileText));

        };

        reader.readAsText(event.target.files[0])

        // Update the formData object
        formData.append(
            "image",
            event.target.files[0],
            event.target.files[0].name
        );
    }

    const actualPixelRatio: number = window.devicePixelRatio;

    return (
        <div>
            {(isMobile && !isTablet && !isLandscape) && <div className=''>
                <div className='header-menu'>

                    <div className='logo-header'>
                        <img className="logo-header" src={process.env.REACT_APP_PUBLIC_URL + "/images//affichemap-logo-mobile.png"}></img>
                    </div>
                    <div className="export-modele-btn">

                        {modeAdmin && <div>
                            <button className="main-button" onClick={exportTemplate} title="Sauvegarder mon modèle JSON"><img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>JSON</button>
                        </div>}
                        {modeAdmin && <div>
                            <button className='main-button download-bottom' onClick={dowload_img} title="Télécharger image .png">
                                <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>IMG
                            </button>
                        </div>}
                        {modeAdmin && <div>
                            <button className='main-button download-bottom' onClick={dowload_pdf} title="Télécharger image .png">
                                <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>PDF
                            </button>
                        </div>}
                        {/*modeAdmin && <div>
                    <button className='main-button download-bottom' onClick={test_cart} title="Télécharger image .png">
                        <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>TESTCART
                    </button>
                </div>*/}
                        {/*modeAdmin && <div className='btn-header'>
                    <CartJSON />
                </div>*/}
                        {/*modeAdmin && <div>
                   <label htmlFor="upload">
                        <button className="main-button" onClick={onFileUpload} title="Importer un modèle"><img className="icone-button-main" src={ process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>IMG</button>
                        <input type="file" id="upload-file" style={{ "display": "none" }} onChange={fileActionUpload} />
                    </label>
                </div>*/}
                    </div>
                    <div className='btn-header'>
                        {/*<Cart />*/}
                        <CartJSON />
                        {/*<Preview />*/}
                    </div>
                </div>

            </div>}

            {/*DESKTOP BLOCK*/ (isDesktop || isTablet || (isMobile && isLandscape)) &&

                <div className='header-menu'>

                    <div className='btn-header'>
                        <button className="main-button" onClick={goBackHome} title="Revenir à la boutique"><img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/back-boutique.svg"}></img>Revenir à la boutique</button>
                    </div>

                    <div className='logo-header'>
                        <img className="logo-header" src={process.env.REACT_APP_PUBLIC_URL + "/images//affichemap-logo-desktop.png"}></img>
                    </div>
                    {modeAdmin && <div className="export-modele-btn">

                        <div>
                            <button className="main-button" onClick={exportTemplate} title="Sauvegarder mon modèle JSON"><img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>JSON</button>
                        </div>
                        <div>
                            <button className='main-button download-bottom' onClick={dowload_img} title="Télécharger image .png">
                                <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>IMG
                            </button>
                        </div>
                        <div>
                            <button className='main-button download-bottom' onClick={dowload_pdf} title="Télécharger image .png">
                                <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>PDF
                            </button>
                        </div>
                        {/*modeAdmin && <div>
                    <button className='main-button download-bottom' onClick={test_cart} title="Télécharger image .png">
                        <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>TESTCART
                    </button>
                </div>*/}
                        {/*modeAdmin && <div className='btn-header'>
                    <CartJSON />
                </div>*/}
                        {/*modeAdmin && <div>
                   <label htmlFor="upload">
                        <button className="main-button" onClick={onFileUpload} title="Importer un modèle"><img className="icone-button-main" src={ process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/folder.svg"}></img>IMG</button>
                        <input type="file" id="upload-file" style={{ "display": "none" }} onChange={fileActionUpload} />
                    </label>
                </div>*/}
                    </div>}
                    <div className='btn-header'>
                        {/*<Cart />*/}
                        <CartJSON />
                        {/*<Preview />*/}
                    </div>
                </div>
            }
        </div>
    );
}